import React, { useEffect, useState } from "react";
import Sidebar from "../../../../component/b2c/sidebar/sidebar";
import NavBar from "../../../../component/b2c/navBar/navBar";
import { useMyContext } from "../../../../context/MyContext";
import { Base_Url, userCodList, fetchUser, CodPlanChange, paymentProcess } from "../../../../config/config";
import { toast } from 'react-toastify';
import Select from 'react-select'
import axios from "axios";
import { FaRupeeSign } from "react-icons/fa";
import ViewRemmitance from "../../../../component/b2c/models/viewRemmitance";
import { FcProcess } from "react-icons/fc";
import '../../../../css/custom-scrollbar.css'
import {
    Eye,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';


const RemittanceList = () => {
    const [remittances, setRemittances] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [data, setData] = useState([]);
    const { isDarkMode, isToggleSidebar,setIsToggleSidebar } = useMyContext()
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [Id, setId] = useState('')
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);

    const cus_id = localStorage.getItem("cus_id");
    const token = localStorage.getItem("token");

    const handleSelectChangeId = (selectedOptions) => {
        if (Array.isArray(selectedOptions)) {
            setSelectedCustomerId(selectedOptions.length > 0 ? selectedOptions.map(opt => opt.value) : []);
        } else if (selectedOptions) {
            setSelectedCustomerId([selectedOptions.value]);
        } else {
            setSelectedCustomerId([]);
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    useEffect(() => {
        fetchRemittanceList();
        fetchCustomers();
    }, []);

    const handleSelectChange = (selected) => {
        if (selected.length > 0) {
            const selectedItem = selected[0];
            setId(selectedItem.value);
        }
    };

    const fetchRemittanceList = async () => {
        try {
            const headers = {
                "Content-Type": "application/json",
                cus_id,
                token,
            };

            const response = await fetch(Base_Url + userCodList, {
                method: "GET",
                headers,
            });

            const result = await response.json();

            if (result.status === "SUCCESS") {
                setRemittances(result.data || []);
            }
            else {
                toast.error(result.message);
            }
        } catch (error) {
            console.error("Failed to fetch remittance data", error);
        }
    };

    const fetchCustomers = async () => {
        const url = Base_Url + fetchUser;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    token: token,
                    cus_id: cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.status === "success") {
                const transformedData = data.data.map(user => {
                    const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
                    return {
                        value: user.id,
                        label: `${capitalizedName} (${user.id})`,
                    };
                });
                setCustomers(transformedData);

            } else {
                toast.error(`Error: ${data.message} (Code: ${data.code})`);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    }

    const payoutCards = [
        {
            id: 'D+1',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 1 Day',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '2% of COD amount',
            note: '(Inclusive GST)',
            color: 'from-gray-700 to-gray-900',
            bgColor: 'bg-gray-100 dark:bg-gray-800',
            iconColor: 'text-gray-700 dark:text-gray-300'
        },
        {
            id: 'D+2',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 2 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1.75% of COD amount',
            note: '(Inclusive GST)',
            color: 'from-gray-600 to-gray-800',
            bgColor: 'bg-gray-100 dark:bg-gray-800',
            iconColor: 'text-gray-700 dark:text-gray-300'
        },
        {
            id: 'D+3',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 3 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1% of COD amount',
            note: '(Inclusive GST)',
            color: 'from-gray-500 to-gray-700',
            bgColor: 'bg-gray-100 dark:bg-gray-800',
            iconColor: 'text-gray-700 dark:text-gray-300'
        },
        {
            id: 'D+4',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 4 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '0.75% of COD amount',
            note: '(Inclusive GST)',
            color: 'from-gray-400 to-gray-600',
            bgColor: 'bg-gray-100 dark:bg-gray-800',
            iconColor: 'text-gray-700 dark:text-gray-300'
        }
    ];

    const navigate = useNavigate();
    const handleActivatePayout = async (cardId) => {
        if (!selectedCustomerId) {
            toast.error("Please select a customer ID.");
            return;
        }
        try {
            const apiUrl = Base_Url + CodPlanChange;
            const headers = {
                cus_id: cus_id,
                token: token,
                "Content-Type": "application/json",
            };

            const payload = {
                retailer_id: selectedCustomerId,
                plan: cardId,
                status: "Active",
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === "SUCCESS") {
                toast.success(response.data.message);
                navigate('/dashboard');
            } else {
                toast.error(response.data?.message || "Activation failed.");
                console.error("Failed to activate payout:", response.data);
            }
        } catch (error) {
            toast.error("Something went wrong.");
            console.error("API error:", error);
        }
    };

    const handleView = (item) => {
        setData(item)
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleProcess = async (item) => {

        try {
            const apiUrl = Base_Url + paymentProcess;
            const headers = {
                cus_id: cus_id,
                token: token,
                "Content-Type": "application/json",
            };

            const payload = {
                retailer_id: item.retailer_id,
                settle_id: item.settle_id,
                status: "Process",
                tnx_id: item.tnx_id,
                amount: item.remaining_amount,
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === "SUCCESS") {
                toast.success(response.data.message);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong.");
        }
    };
    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    const getStatusBadgeClass = (status) => {
        const s = status?.toLowerCase();
        if (isDarkMode) {
            if (s === 'completed' || s === 'processed') {
                return 'bg-emerald-500/10 text-emerald-300 border-emerald-500/40 shadow-[0_0_10px_rgba(16,185,129,0.2)]';
            }
            if (s === 'pending') {
                return 'bg-amber-500/10 text-amber-300 border-amber-500/40 shadow-[0_0_10px_rgba(245,158,11,0.2)]';
            }
            return 'bg-gray-500/10 text-gray-400 border-gray-600/40';
        }
        if (s === 'completed' || s === 'processed') {
            return 'bg-green-100 text-green-700';
        }
        if (s === 'pending') {
            return 'bg-yellow-100 text-yellow-700';
        }
        return 'bg-gray-100 text-gray-600';
    };

    // Mobile card view for each remittance row
    const renderMobileCard = (item, index) => (
        <div
            key={item.id || index}
            className={`rounded-xl border overflow-hidden transition-all duration-200 ${
                isDarkMode
                    ? 'bg-gradient-to-br from-[#0f172a] via-[#0b1220] to-[#0f172a] border-indigo-500/25 shadow-[0_4px_20px_rgba(79,70,229,0.15)]'
                    : 'bg-white border-gray-200 shadow-sm'
            }`}
        >
            {/* Top strip: Settled ID + Amount */}
            <div className={`flex items-center justify-between gap-3 px-3 py-2.5 border-b ${
                isDarkMode
                    ? 'bg-gradient-to-r from-indigo-600/20 via-purple-600/15 to-indigo-600/20 border-indigo-500/25'
                    : 'bg-gray-50 border-gray-200'
            }`}>
                <div className="min-w-0 flex-1">
                    <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
                        isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
                    }`}>
                        Settled ID
                    </p>
                    <p className={`text-[11px] font-mono font-semibold truncate ${
                        isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                        {item.settle_id || '—'}
                    </p>
                </div>
                <div className="text-right shrink-0">
                    <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
                        isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
                    }`}>
                        COD Amount
                    </p>
                    <p className={`text-[14px] font-bold ${
                        isDarkMode
                            ? 'bg-gradient-to-r from-emerald-300 to-teal-300 bg-clip-text text-transparent'
                            : 'text-gray-900'
                    }`}>
                        ₹{item.remaining_amount}
                    </p>
                </div>
            </div>

            {/* Body: detail rows */}
            <div className={`px-3 py-2 divide-y ${
                isDarkMode ? 'divide-indigo-500/15' : 'divide-gray-100'
            }`}>
                <div className="flex items-center justify-between py-2">
                    <span className={`text-[10px] font-medium uppercase tracking-wider ${
                        isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
                    }`}>
                        Retailer ID
                    </span>
                    <span className={`text-[11px] font-semibold ${
                        isDarkMode ? 'text-indigo-100' : 'text-gray-800'
                    }`}>
                        {item.retailer_id || '—'}
                    </span>
                </div>

                <div className="flex items-center justify-between py-2 gap-3">
                    <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
                        isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
                    }`}>
                        Status
                    </span>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-semibold border capitalize ${getStatusBadgeClass(item.status)}`}>
                        <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                            item.status?.toLowerCase() === 'completed' || item.status?.toLowerCase() === 'processed'
                                ? 'bg-emerald-400 animate-pulse'
                                : item.status?.toLowerCase() === 'pending'
                                    ? 'bg-amber-400 animate-pulse'
                                    : 'bg-gray-400'
                        }`}></span>
                        {item.status || '—'}
                    </span>
                </div>
            </div>

            {/* Action buttons */}
            <div className={`flex items-center justify-end gap-2 px-3 py-2 border-t ${
                isDarkMode ? 'border-indigo-500/15 bg-indigo-500/5' : 'border-gray-100 bg-gray-50'
            }`}>
                <button
                    onClick={() => handleView(item)}
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-[10px] font-medium transition-all duration-150 ${
                        isDarkMode
                            ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_8px_rgba(99,102,241,0.4)]'
                            : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    <Eye size={12} />
                    View
                </button>
                <button
                    onClick={() => handleProcess(item)}
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-[10px] font-medium transition-all duration-150 ${
                        isDarkMode
                            ? 'border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 hover:shadow-[0_0_8px_rgba(16,185,129,0.4)]'
                            : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    <FcProcess size={12} />
                    Process
                </button>
            </div>
        </div>
    );

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-white'}`}>
                <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

                <NavBar />
                <div className="flex flex-1 overflow-hidden">

                   {isToggleSidebar && (
                   <div
                     className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                     onClick={() => setIsToggleSidebar(false)}
                   />
                 )}
       
                 <div
                   className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                 >
                   <Sidebar />
                 </div>

                    <div className={`flex flex-1 flex-col w-full rounded-custom overflow-y-auto p-3 custom-scrollbar transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120] text-gray-200' : 'bg-gray-100'}`}>
                        {/* Header */}
                        <div className="mb-5 text-center">
                            <div className="inline-flex items-center gap-2 mb-2">
                                <div className={`p-1.5 rounded transition-colors duration-300 ${isDarkMode
                                        ? 'border border-indigo-500/40 bg-indigo-500/10 shadow-[0_0_15px_rgba(99,102,241,0.2)]'
                                        : 'border border-gray-300 bg-gray-200'
                                    }`}>
                                    <FaRupeeSign className={`w-4 h-4 ${isDarkMode ? 'text-indigo-400' : 'text-gray-700'}`} />
                                </div>
                                <h1 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Remittance Dashboard
                                </h1>
                            </div>
                            <p className={`text-[10px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                Monitor your payment settlements, track remittance history, and manage upcoming payouts
                            </p>
                        </div>

                        {/* Payout Cards */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                            {payoutCards.map((card, index) => (
                                <div
                                    key={card.id}
                                    className={`relative overflow-hidden rounded-lg transition-all duration-300 hover:shadow-md ${isDarkMode
                                            ? 'bg-gradient-to-br from-[#1F2937] to-[#111827] border border-gray-800 hover:border-indigo-500/40 hover:shadow-[0_0_20px_rgba(99,102,241,0.2)]'
                                            : 'bg-white border border-gray-200'
                                        } shadow-sm`}
                                >
                                    {/* Top gradient bar */}
                                    {isDarkMode && (
                                        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"></div>
                                    )}
                                    <div className="py-3 px-3 text-center">
                                        <h4 className={`text-[9px] font-medium uppercase tracking-wide mb-0.5 ${isDarkMode ? 'text-indigo-300' : 'text-gray-500'}`}>
                                            {card.frequency}
                                        </h4>
                                        <h3 className={`text-[11px] font-bold mb-0.5 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                            {card.title}
                                        </h3>
                                        <p className={`text-[9px] mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                            {card.subtitle}
                                        </p>
                                        <div className={`text-base font-bold mb-0.5 ${isDarkMode ? 'text-emerald-400' : 'text-gray-800'}`}>
                                            {card.percentage}
                                        </div>
                                        <p className={`text-[8px] mb-2 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                            {card.note}
                                        </p>
                                        <button
                                            onClick={() => handleActivatePayout(card.id)}
                                            disabled={!selectedCustomerId}
                                            className={`w-full py-1.5 px-2 rounded-lg font-semibold text-[10px] transition-all duration-200 ${!selectedCustomerId
                                                ? 'bg-gray-300 dark:bg-gray-800 text-gray-500 dark:text-gray-600 cursor-not-allowed'
                                                : isDarkMode
                                                    ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-[0_0_15px_rgba(99,102,241,0.5)]'
                                                    : 'bg-red-600 text-white hover:opacity-80'
                                                }`}
                                        >
                                            Activate
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Customer Select */}
                        <div className="mt-4">
                            <label htmlFor="Id" className={`block text-[10px] font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                Select Retailer ID
                            </label>
                            <Select
                                options={customers}
                                onChange={handleSelectChangeId}
                                placeholder="Search and select retailer..."
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        padding: "0.2rem",
                                        borderRadius: "0.5rem",
                                        minHeight: "32px",
                                        fontSize: "11px",
                                        backgroundColor: isDarkMode ? "#1F2937" : "#ffffff",
                                        borderColor: isDarkMode ? "#374151" : "#d1d5db",
                                        color: isDarkMode ? "white" : "#1f2937",
                                        boxShadow: isDarkMode ? 'none' : base.boxShadow,
                                        '&:hover': {
                                            borderColor: isDarkMode ? '#6366f1' : '#9ca3af',
                                        },
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: isDarkMode ? "white" : "#1f2937",
                                        fontSize: "11px",
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: "11px",
                                        color: isDarkMode ? "#9ca3af" : "#6b7280",
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        backgroundColor: isDarkMode ? "#1F2937" : "#ffffff",
                                        border: isDarkMode ? "1px solid #374151" : "1px solid #d1d5db",
                                        fontSize: "11px",
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isFocused
                                            ? (isDarkMode ? "#111827" : "#f3f4f6")
                                            : (isDarkMode ? "#1F2937" : "#ffffff"),
                                        color: isDarkMode ? "white" : "#1f2937",
                                        fontSize: "11px",
                                        cursor: "pointer",
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        color: isDarkMode ? "white" : "#1f2937",
                                    }),
                                }}
                            />
                        </div>

                        {/* Table */}
                        <div className={`overflow-x-auto mt-4 rounded-lg border transition-colors duration-300 ${isDarkMode
                                ? 'border-gray-800 bg-[#111827] shadow-[0_0_30px_rgba(0,0,0,0.4)]'
                                : 'border-gray-200'
                            }`}>
                            {/* Mobile/Tablet Card View (hidden on lg+) */}
                            <div className="lg:hidden p-2 space-y-3">
                                {remittances.length === 0 ? (
                                    <div className={`text-center py-6 text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                                        No Data Found
                                    </div>
                                ) : (
                                    remittances.map((item, index) => renderMobileCard(item, index))
                                )}
                            </div>

                            {/* Desktop Table View (hidden below lg) */}
                            <table className="hidden lg:table min-w-full table-fixed">
                                <thead className={`transition-colors duration-300 ${isDarkMode
                                        ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937] border-b border-gray-700'
                                        : 'bg-gray-200'
                                    }`}>
                                    <tr>
                                        <th className={`py-1.5 px-2 text-left text-[9px] font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Settled ID</th>
                                        <th className={`py-1.5 px-2 text-left text-[9px] font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Retailer ID</th>
                                        <th className={`py-1.5 px-2 text-left text-[9px] font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Status</th>
                                        <th className={`py-1.5 px-2 text-left text-[9px] font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>COD Amount</th>
                                        <th className={`py-1.5 px-2 text-center text-[9px] font-semibold uppercase tracking-wider ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Action</th>
                                    </tr>
                                </thead>
                                <tbody className={`divide-y transition-colors duration-300 ${isDarkMode ? 'divide-gray-800' : 'divide-gray-100'}`}>
                                    {remittances.length === 0 ? (
                                        <tr>
                                            <td
                                                colSpan={5}
                                                className={`py-6 text-center text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    ) : (
                                        remittances.map((item, index) => (
                                            <tr
                                                key={item.id}
                                                className={`transition-colors duration-150 ${isDarkMode
                                                        ? index % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]'
                                                        : index % 2 === 0 ? 'bg-white hover:bg-gray-50' : 'bg-gray-50/50 hover:bg-gray-50'
                                                    }`}
                                            >
                                                <td className={`py-1.5 px-2 text-[10px] font-mono ${isDarkMode ? 'text-indigo-300' : 'text-gray-600'}`}>
                                                    {item.settle_id}
                                                </td>
                                                <td className={`py-1.5 px-2 text-[10px] font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                                                    {item.retailer_id}
                                                </td>
                                                <td className="py-1.5 px-2">
                                                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-semibold border ${getStatusBadgeClass(item.status)}`}>
                                                        <span className={`w-1.5 h-1.5 rounded-full mr-1 ${item.status?.toLowerCase() === 'completed' || item.status?.toLowerCase() === 'processed'
                                                                ? 'bg-emerald-400 animate-pulse'
                                                                : item.status?.toLowerCase() === 'pending'
                                                                    ? 'bg-amber-400 animate-pulse'
                                                                    : 'bg-gray-400'
                                                            }`}></span>
                                                        {item.status || '—'}
                                                    </span>
                                                </td>
                                                <td className={`py-1.5 px-2 text-[10px] font-semibold ${isDarkMode ? 'text-emerald-400' : 'text-gray-800'}`}>
                                                    ₹{item.remaining_amount}
                                                </td>
                                                <td className="py-1.5 px-2">
                                                    <div className="flex items-center justify-center gap-1.5">
                                                        <button
                                                            onClick={() => handleView(item)}
                                                            className={`p-1.5 rounded border transition-all duration-150 ${isDarkMode
                                                                    ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_8px_rgba(99,102,241,0.4)]'
                                                                    : 'border-gray-300 text-gray-500 hover:bg-gray-100'
                                                                }`}
                                                            title="View"
                                                        >
                                                            <Eye size={13} />
                                                        </button>
                                                        <button
                                                            onClick={() => handleProcess(item)}
                                                            className={`p-1.5 rounded border transition-all duration-150 ${isDarkMode
                                                                    ? 'border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 hover:shadow-[0_0_8px_rgba(16,185,129,0.4)]'
                                                                    : 'border-gray-300 text-gray-500 hover:bg-gray-100'
                                                                }`}
                                                            title="Process"
                                                        >
                                                            <FcProcess size={13} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Footer note */}
                        <div className="mt-3 text-center">
                            <p className={`text-[8px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                Showing {remittances.length} remittance records
                            </p>
                        </div>
                    </div>
                </div>
                <ViewRemmitance isopen={isPopupOpen} onClose={handleClose} data={data} />
            </div>
        </>
    );
};

export default RemittanceList;